// extracted by mini-css-extract-plugin
module.exports = {"root":"thumbnail_root__1wuDD","rootSelected":"thumbnail_rootSelected__2oOQX thumbnail_root__1wuDD","image":"thumbnail_image__zNhOG"};